import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { supabase, isSupabaseConfigured } from '@/lib/supabase';
import { AuthShell, authButton, PasswordInput } from '@/components/AuthShell';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!isSupabaseConfigured) return;
    const { error } = await supabase.auth.updateUser({ password });
    if (error) toast.error(error.message);
    else { toast.success('Mot de passe mis à jour. Connecte-toi.'); navigate('/login'); }
  };

  return (
    <AuthShell title="Nouveau mot de passe" subtitle="Choisis un nouveau mot de passe.">
      <form onSubmit={submit} className="space-y-4">
        <PasswordInput required minLength={6} placeholder="Nouveau mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
        <button type="submit" disabled={!isSupabaseConfigured} className={authButton} data-testid="reset-submit">Mettre à jour</button>
      </form>
    </AuthShell>
  );
}
